import {forgetPasswordTypes} from "../../../actions/AuthActions/AuthActionsTypes/ForgetPasswordActionsTypes";

const initState = {};

const ForgetPasswordErrorReducer = (state = initState, action) => {
    switch (action.type) {
        case forgetPasswordTypes.SET_ERROR: {
            return Object.assign({}, state, {
                [action.name]: action.message,
            });
        }

        case forgetPasswordTypes.REMOVE_ERRORS: {
            return initState;
        }

        default: {
            return state;
        }
    }
};


export default ForgetPasswordErrorReducer;
